// extracted by mini-css-extract-plugin
export var flushBottom = "mWd4BDPnxOEPM8t6Sjqe";
export var flushLeft = "fyhvARDTypspkFO8WAAT";
export var flushRight = "xg796Li32XS87orpMhWt";
export var flushTop = "bLjxFEu0W9YEtxCWh772";
export var label = "irbEhKtiC3zQb1It5nXg";
export var leadingItem = "OSwoxvAV3_toD_0TfcFs";
export var onClick = "vWjXBhdxVHEKz14c5yHv";
export var smallSpacing = "FaAvf_AiGVcxtVFgJbiT";
export var tag = "OerpmTGvmNXBD2TvcfuL";
export var trailingItem = "k1RqJ8xLtPLH11nEoff4";